export const clearLocalStorage = () => {
  localStorage.clear('auth');
};

export const saveToLocalStorage = (user, token) => {
  const now = new Date();
  const expiry = new Date(now.getTime() + 15 * 60000);
  localStorage.setItem('auth', JSON.stringify({ user, token, expiry }));
};
